import { colors } from '@insurancemenu/imenu-components-lib';
import { TABLE_HEADER_BG_COLOR } from '@insurancemenu/imenu-components-lib/dist/components/tables/utils/constants';
import { createUseStyles } from 'react-jss';

const styles = {
  content: {
    paddingBottom: '5rem',
    maxWidth: '170rem',
    margin: '0 auto',
  },
  dateRange: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'center',
  },
  tableWrapper: {
    overflow: 'hidden',
    backgroundColor: colors.neutral.white,
    borderRadius: '1rem',
    marginBottom: '5rem',
    boxShadow: 'rgba(0, 0, 0, 0.14) 0px 4px 8px',
  },
  table: {
    width: 'max(100%, 108rem)',
  },
  tableHeading: {
    padding: '1.6rem 0.5rem',
    width: '4rem',
    backgroundColor: TABLE_HEADER_BG_COLOR,
    '&:first-child': {
      paddingLeft: '2.4rem',
    },
    '&:nth-child(3)': {
      width: '8rem',
      paddingRight: '4rem',
    },
    '&:last-child': {
      paddingRight: '2.4rem',
      width: '8rem',
    },
  },
  headingsRow: {
    borderTop: `0.1rem solid ${colors.neutral[500]}`,
  },
  actionHeader: {
    display: 'flex',
    gap: '3rem',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    marginBottom: '8rem',
    '@media(max-width:1350px)': {
      justifyContent: 'center',
    },
  },
  filters: {
    display: 'flex',
    gap: '3rem',
    alignItems: 'center',
  },
  textArea: {
    '& textarea': {
      backgroundColor: colors.neutral.white,
    },
    marginTop: '2rem',
  },
  selectedFile: {
    margin: '0 0.5rem',
    color: colors.neutral[900],
    wordBreak: 'break-all',
    lineHeight: '3rem',
  },
  downloadButtonWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: '2rem',
    justifyContent: 'flex-end',
  },
  infoButton: {
    cursor: 'pointer',
  },
  tooltipWrapper: {
    textTransform: 'none',
    display: 'inline-flex',
  },
  downloadAllButton: {
    backgroundColor: colors.neutral.white,
    minWidth: '20rem',
    '&:disabled': {
      backgroundColor: colors.neutral[300],
    },
  },
};

const createStyles = createUseStyles(styles);
export { createStyles };
